function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-Meter",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C16.8414549,2 20.8793269,5.44054761 21.8019922,10.0100191 C21.8666543,10.0033003 21.9329418,10 22,10 C23.1045695,10 24,10.8954305 24,12 C24,13.1045695 23.1045695,14 22,14 C21.9329418,14 21.8666543,13.9966997 21.8012913,13.9902527 C20.8793269,18.5594524 16.8414549,22 12,22 C7.15854507,22 3.12067309,18.5594524 2.19800783,13.9899809 C2.13334565,13.9966997 2.06705824,14 2,14 C0.8954305,14 1.3527075e-16,13.1045695 0,12 C-1.3527075e-16,10.8954305 0.8954305,10 2,10 C2.06705824,10 2.13334565,10.0033003 2.19870868,10.0097473 C3.12067309,5.44054761 7.15854507,2 12,2 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M14,14 C14.5522847,14 15,14.4477153 15,15 C15,15.5522847 14.5522847,16 14,16 L10,16 C9.44771525,16 9,15.5522847 9,15 C9,14.4477153 9.44771525,14 10,14 L14,14 Z M16,8 C16.5522847,8 17,8.44771525 17,9 L17,11 C17,11.5522847 16.5522847,12 16,12 L8,12 C7.44771525,12 7,11.5522847 7,11 L7,9 C7,8.44771525 7.44771525,8 8,8 L16,8 Z",
  id: "Combined-Shape",
  fill: "#60CAA8"
}));

var SvgMeter = function SvgMeter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMeter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meter.533b4079.svg";
export { ForwardRef as ReactComponent };